import { createContext, useContext } from 'react';
import { Wws_Page } from '../types/graphql';
import useGetActiveSinglePageSection from '../lib/hooks/useGetActiveSinglePageSection';

interface IActiveSinglePageSectionContext {
  activeSectionId: string | undefined;
}

const ActiveSinglePageSectionContext =
  createContext<IActiveSinglePageSectionContext | null>(null);

type ActiveSinglePageSectionProviderProps = {
  children: React.ReactNode;
  pages: Wws_Page[];
};

export const ActiveSinglePageSectionProvider = ({
  children,
  pages,
}: ActiveSinglePageSectionProviderProps) => {
  const activeSectionId = useGetActiveSinglePageSection(pages, true);

  return (
    <ActiveSinglePageSectionContext.Provider value={{ activeSectionId }}>
      {children}
    </ActiveSinglePageSectionContext.Provider>
  );
};

export const useActiveSinglePageSectionContext = () => {
  const context = useContext(ActiveSinglePageSectionContext);

  if (!context) {
    return {
      activeSectionId: undefined,
    };
  }

  return context;
};
